import { PATENTE_LOCKED } from 'presupuestador/lib/constants';
import { put, call } from 'redux-saga/effects';
import { BFFAgent } from '../../../../common/BFFAgent';
import {
    PRESUPUESTADOR_VALIDATE_PATENT_APPRAISED,
    PRESUPUESTADOR_SEARCH_PATENT_SUCCESS,
    PRESUPUESTADOR_SEARCH_PATENT_BEGIN,
    PRESUPUESTADOR_SEARCH_PATENT_FAILURE
} from '../constants';


export default function* searchPatentSaga({ data: { patente, isCurrent, status } }) {
    try {
        
        yield put({
            type: PRESUPUESTADOR_SEARCH_PATENT_BEGIN,
            data: { patentPending: true }
        })

        const {locked} = yield call (BFFAgent.Peritador.getLockedPatent, patente)
        
        if (locked){
            throw {
                type: 'patenteBloqueada',
                message: PATENTE_LOCKED,
            }
        }
        
        const { peritaje, peritajeQuote } = yield call(BFFAgent.Peritador.getPeritaje, patente, false, isCurrent, status);
        
        if (!peritaje) {
            throw {
                type: 'noPeritado', 
                message: 'La patente no está peritada'
            }
        }


        yield put({
            type: PRESUPUESTADOR_SEARCH_PATENT_SUCCESS,
            data: { peritajeQuote, patente, peritaje, patentPending: false }
        })


    } catch (error) {
        yield put({
            type: PRESUPUESTADOR_SEARCH_PATENT_FAILURE,
            data: { patentPending: false }
        })
        yield put({
            type: PRESUPUESTADOR_VALIDATE_PATENT_APPRAISED,
            data: {
                patenteCodeError: {
                    code: error.type,
                    message: error.message
                }
            }
        })
    }

}
